import { OrderDirection } from '../../../../../../gen-src/queries';
import { OrderBy } from './OrderBy';

export type SortProviderProps<OrderFields extends string> = {
  readonly defaultField: OrderFields;
  readonly validOrderFieldsWithDefaultDirections: DefaultDirections<OrderFields>;
  readonly children: (props: SortProviderChildProps<OrderFields>) => React.ReactNode;
};

export type DefaultDirections<OrderFields extends string> = Record<OrderFields, OrderDirection>;

export type SortProviderChildProps<OrderFields extends string> = {
  readonly orderBy: OrderBy<OrderFields>;
  readonly updateSortOrder: (sortField: OrderFields) => void;
};

export function buildDefaultOrder<OrderFields extends string>(
  defaultField: OrderFields,
  defaultDirections: DefaultDirections<OrderFields>,
): OrderBy<OrderFields> {
  return {
    field: defaultField,
    direction: defaultDirections[defaultField],
  };
}
